export default function(state = [], action = {}) {
    switch (action.type) {
        case 'SET_SHOP_APPOINTMENT_INTERVALS':
			return action.shopAppointmentIntervals.map((interval) => {
                return interval;
            });
        default:
            return state;
    }
}